import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printKeyValue } from '../../output.js'

export const servicesGetCommand = new Command(`get`)
  .description(`Show service details`)
  .argument(`<id>`, `Service ID`)
  .action(async (serviceId: string) => {
    const json = servicesGetCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.services.get({ serviceId })

      if (isQuiet()) {
        printQuiet(result.id)
        return
      }

      if (json) {
        printJson(result)
      } else {
        const pairs: [string, string][] = [
          [`ID:`, result.id],
          [`Name:`, result.name],
          [`Type:`, result.type],
          [`Environment:`, result.environmentId],
        ]
        if (`status` in result && result.status) {
          pairs.push([`Status:`, result.status])
        }
        if (`region` in result && result.region) {
          pairs.push([`Region:`, result.region])
        }
        if (`baseUrl` in result && result.baseUrl) {
          pairs.push([`Base URL:`, result.baseUrl])
        }
        printKeyValue(pairs)
      }
    } catch (error) {
      await handleError(error, json)
    }
  })
